import React, { useEffect, useState } from "react";

import images from "../../../utils/images";

export default function Header(props) {
  const [animate, setAnimate] = useState("");

  useEffect(() => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });

    setTimeout(function () {
      setAnimate("loaded");
    }, 1000);

    setTimeout(function () {
      setAnimate("loaded cta");
    }, 2000);
  }, []);

  const goToShareResults = () => {
    window.scrollTo({
      behavior: "smooth",
      top: document.getElementById("shareResults").offsetTop - 40,
    });
  };

  return (
    <header className={animate} id="a5-summary-header">
      <div className="wrap">
        <a className="a5-summary-header-logo" href="/">
          <span>
            <img alt="aptihealth" src={images("./common/logo.svg")} />
          </span>
          {props.name ? null : (
            <strong>
              Transforming
              <br /> Behavioral Healthcare
            </strong>
          )}
        </a>
        {props.name ? (
          <h5>
            <span>
              <em>&amp;</em> <strong>{props.name}</strong>
            </span>
          </h5>
        ) : null}
        {props.isPublic && (
          <button className="btn" onClick={goToShareResults}>
            Send Results <br />
            to Your <br />
            Healthcare Provider
          </button>
        )}
      </div>
    </header>
  );
}
